import * as config from "@/constants/config";
import { saveAs } from "file-saver";

export default {
  DownloadDTA: function(site, appendName = true) {
    let toDownload = {
      APIKEY: site.apikey,
      APISITEID: site.siteId
    };

    let blob = new Blob([JSON.stringify(toDownload)], {
      type: "text/plain;charset=utf-8"
    });

    saveAs(
      blob,
      config.DTAFilename +
        (appendName ? config.DTASeparator + site.name : "") +
        config.DTAExtension
    );
  }
};
